import { useModal } from "@ebay/nice-modal-react";
import { useState } from "react";

import CodeEditor from "components/CodeEditor";
import DocumentationIconButton from "components/DocumentationIconButton";
import Banner from "ds/components/Banner";
import Box from "ds/components/Box";
import Button from "ds/components/Button";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerFooter from "ds/components/Drawer/Footer";
import DrawerFooterActions from "ds/components/Drawer/FooterActions";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCancelButton from "ds/components/DrawerNew/CancelButton";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerForm from "ds/components/DrawerNew/Form";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import Typography from "ds/components/Typography";
import { getDocsUrl } from "utils/getDocsUrl";

import styles from "./styles.module.css";

type TriggerWithCustomConfigDrawerProps = {
  onTrigger: (config: string) => void;
};

const TriggerWithCustomConfigDrawer = createDrawer(
  ({ onTrigger }: TriggerWithCustomConfigDrawerProps) => {
    const [config, setConfig] = useState("");

    const drawer = useModal();

    const handleTrigger = () => {
      onTrigger(config);
      drawer.hide();
    };

    const isDirty = config !== "";

    return (
      <DrawerForm isDirty={isDirty}>
        <DrawerHeader justify="between">
          <DrawerHeaderTitle title="Runtime config details" />
          <Box align="center" gap="medium">
            <DocumentationIconButton
              tooltipText="Go to documentation"
              size="small"
              variant="ghost"
              href={getDocsUrl(
                "/concepts/run/tracked#triggering-runs-with-a-custom-runtime-config"
              )}
            />
            <DrawerCloseIcon />
          </Box>
        </DrawerHeader>
        <DrawerBody fullHeight>
          <Banner variant="info" margin="0 0 x-large 0">
            To type runtime config, please use YAML format.
          </Banner>
          <Typography tag="span" variant="p-t7">
            Runtime config
          </Typography>
          <Box direction="column" margin="large 0 0 0" className={styles.codeEditorWrapper}>
            <CodeEditor
              language="yaml"
              body={config}
              onChange={(value?: string) => setConfig(value ?? "")}
              options={{ automaticLayout: true }}
              rounded
            />
          </Box>
        </DrawerBody>
        <DrawerFooter>
          <DrawerFooterActions>
            <DrawerCancelButton />
            <Button disabled={!config} variant="primary" onPress={handleTrigger}>
              Trigger
            </Button>
          </DrawerFooterActions>
        </DrawerFooter>
      </DrawerForm>
    );
  }
);

export const showTriggerWithCustomConfigDrawer = createDrawerTrigger(TriggerWithCustomConfigDrawer);
